import { FC } from "react";
import { useTranslation } from "react-i18next";

import { NotificationBell } from "@ryde/controls";
import { useNotificationBell } from "@ryde/shared";

import { LeftBarButton } from "./left-bar.button";

export const LeftBarNotificationBell: FC = () => {
  const { t } = useTranslation();
  const { onMenuItemClick, badgeContent, isBadge, isNotificationDrawerOpened } =
    useNotificationBell();
  return (
    <LeftBarButton
      onMenuItemClick={onMenuItemClick}
      tooltip={t(`notification.plural`)}
    >
      <NotificationBell
        badgeContent={badgeContent}
        isBadge={isBadge}
        isActive={isNotificationDrawerOpened}
      />
    </LeftBarButton>
  );
};
